export const frameDimensions = {
	width: 380,
	height: 760,
};
